export default {
  discord: 'https://discord.gg/7SewPZreMe',
};
